import { render, staticRenderFns } from "./TeamCardTournament.vue?vue&type=template&id=95433178&scoped=true"
import script from "./TeamCardTournament.vue?vue&type=script&lang=js"
export * from "./TeamCardTournament.vue?vue&type=script&lang=js"
import style0 from "./TeamCardTournament.vue?vue&type=style&index=0&id=95433178&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95433178",
  null
  
)

export default component.exports